import { ErrorMessage } from "components/shared/ErrorMessage";
import { ReactNode, VFC } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { ErrorBoundary } from "shared/components/ErrorBoundary";
import { mapMessages } from "shared/mapMessages";
import { sharedMessages } from "shared/sharedMessages";

const messages = mapMessages("components.shared.LoadingRegionErrorBoundary", {
    errorText: "Failed to load {contentName}.",
});

type Props = {
    children: ReactNode,
    contentName: MessageDescriptor | string;
};

export const LoadingRegionErrorBoundary: VFC<Props> = ({
    children,
    contentName,
}) => (
    <ErrorBoundary fallback={<ErrorFallback contentName={contentName} />}>
        {children}
    </ErrorBoundary>
);

const ErrorFallback: VFC<Pick<Props, "contentName">> = ({ contentName }) => {
    const intl = useIntl();
    const messageValues: { contentName: string } = { contentName: typeof contentName === "string" ? contentName : intl.formatMessage(contentName) };

    return <div aria-busy="false">
        <ErrorMessage message={sharedMessages.requestFailedBody} heading={messages.errorText} headerValues={messageValues} />
    </div>;
};
